import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ep-search',
  templateUrl: './ep-search.component.html',
  styleUrls: ['./ep-search.component.scss'],
})
export class EpSearchComponent {
  @Input() placeholder = '';
  @Input() searchText = '';
  @Output() searchClick: EventEmitter<string> = new EventEmitter<string>();

  private wasPreviouslySubmitted = false;

  public submitSearch(): void {
    this.wasPreviouslySubmitted = true;
    this.searchClick.emit(this.searchText);
  }

  public onKeyUp(keyboardEvent: KeyboardEvent): void {
    if ((keyboardEvent.code === 'Backspace' || keyboardEvent.code === 'Delete') && this.searchText.length === 0 && this.wasPreviouslySubmitted) {
      this.clearSearch();
    }
  }

  public search(): void {
    if (this.searchText.length === 0 && this.wasPreviouslySubmitted) {
      this.clearSearch();
    }
  }

  private clearSearch() {
    this.wasPreviouslySubmitted = false;
    this.searchClick.emit(this.searchText);
  }
}
